import script from "./ViewTopsTournament.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewTopsTournament.vue?vue&type=script&setup=true&lang=js"

import "./ViewTopsTournament.vue?vue&type=style&index=0&id=7ad2aef6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ad2aef6"]])

export default __exports__